/* eslint-disable */

import moment from "moment";
import { ACTION_TYPE } from '../actions/ActionTypes'

const INITIAL_STATE = {
  currentAssetProducing: {
    id: undefined,
    location: undefined,
    owner: "",
    smartMeter: "",
    operationalSince: moment().format("x"),
    active: true,
    displayGraphData: true,
    organization: {},
    organizations: [],
    countryLink: {},
    assetType: 0,
    capacityWh: 123456,
    momentTimezone: "",
    registryCompliance: 0,
    otherGreenAttributes: "NA",
    typeOfPublicSupport: "NA",
    sourceHistory: [],
    assetID: "",
    source: "",
    sourceID: "",
    periodNumber: "NA",
    periodType: "minute"
  },
  localProdAssetPicture: null,
  graphDataProducer: {
    doughnutChartLabels: [],
    doughnutChartData: [],
    doughnutChartLastDayData: [],
    doughnutData: [],
    barChartData: [],
    barChartLabels: []
  },
  assetsProducing: [],
  error: { message: "", isVisible: false },
  loadingMeterRead: false,
  loading: false,
  loadingForm: false,
  order: "asc",
  orderBy: "id",
  selected: [],
  page: 0,
  rowsPerPage: 10,
  thirtyDaysButtonPressed: false,
  customButtonPressed: false,
  dialogStartDateOpen: false,
  dialogEndDateOpen: false,
  startDate: moment().toDate(),
  endDate: moment().toDate(),
  showDateFilter: false
};

const assetsProducingReducer = (state = INITIAL_STATE, action) => { 
  switch (action.type) {
    case "GET_ASSET_PRODUCING_DATA_SUCCESS":
      return { ...state, graphDataProducer: action.payload, loading: false };
    //AssetsProducing CRUD
    case "CREATE_ASSET_PRODUCING_START":
      return { ...state, loading: true };
    case "CREATE_ASSET_PRODUCING_SUCCESS":
      return { ...state, loading: false };
    case "CREATE_ASSET_PRODUCING_FAIL":
      return { ...state, loading: false };
    case "UPDATE_ASSET_PRODUCING_START":
      return { ...state, loading: true };

    case "ARCHIVE_ASSET_PRODUCING_START":
      return { ...state, loading: true };
    case "ARCHIVE_ASSET_PRODUCING_SUCCESS":
      return {
        ...state,
        loading: false,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          active: false
        }
      };
    case "ARCHIVE_ASSET_PRODUCING_FAIL":
      return { ...state, loading: false };
      
    case "RESTORE_ASSET_PRODUCING_START":
      return { ...state, loading: true };
    case "RESTORE_ASSET_PRODUCING_SUCCESS":
      return {
        ...state,
        loading: false,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          active: true
        }
      };
    case "RESTORE_ASSET_PRODUCING_FAIL":
      return { ...state, loading: false };

    case "UPDATE_ASSET_PRODUCING_SUCCESS":
      return { ...state, loading: false };
    case "UPDATE_ASSET_PRODUCING_FAIL":
      return { ...state, loading: false };
      
    case "DELETE_ASSET_PRODUCING_START":
      return { ...state, loading: true };
    case "DELETE_ASSET_PRODUCING_SUCCESS":
      return { ...state, loading: false };
    case "DELETE_ASSET_PRODUCING_FAIL":
      return { ...state, loading: false };

    case ACTION_TYPE.ASSET_PRODUCING.THIRTY_DAYS_BUTTON_PRESSED: 
    return { 
      ...state, 
      thirtyDaysButtonPressed: true,
      customButtonPressed: false,
    };

    case ACTION_TYPE.ASSET_PRODUCING.CUSTOM_BUTTON_PRESSED:
      return { 
        ...state, 
        thirtyDaysButtonPressed: false,
        customButtonPressed: true,
      };

    case ACTION_TYPE.ASSET_PRODUCING.TOGGLE_START_DATE_DIALOG: {
      const dialogStartDateOpen = !state.dialogStartDateOpen
      return {
        ...state, 
        dialogStartDateOpen: dialogStartDateOpen
      }
    }

    case ACTION_TYPE.ASSET_PRODUCING.TOGGLE_END_DATE_DIALOG: {
      const dialogEndDateOpen = !state.dialogEndDateOpen
      return {
        ...state, 
        dialogEndDateOpen: dialogEndDateOpen
      }
    }

    case ACTION_TYPE.ASSET_PRODUCING.SET_START_DATE: 
      return {
        ...state, 
        startDate: action.payload
      }

    case ACTION_TYPE.ASSET_PRODUCING.SET_END_DATE: 
      return {
        ...state, 
        endDate: action.payload
      }

    case ACTION_TYPE.ASSET_PRODUCING.DISPLAY_DATE_FILTER:
      return { ...state, showDateFilter: true }

    case ACTION_TYPE.ASSET_PRODUCING.HIDE_DATE_FILTER:
      return { ...state, showDateFilter: false }
    
    //AssetsProducing data changing
    case "PROD_ASSET_OWNER_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          owner: action.payload
        }
      };

    case "PROD_ASSET_ORGANIZATION_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          organization: action.payload
        }
      };

    case "PROD_ASSET_ORGANIZATIONS_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          organizations: action.payload
        }
      };

    case "PROD_ASSET_COUNTRY_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          countryLink: action.payload
        }
      };

    case "PROD_ASSET_PICTURE_CHANGED":
      return {
        ...state,
        localProdAssetPicture: action.payload
      };

    case "PROD_ASSET_DISPLAYED_NAME_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          displayedName: action.payload
        }
      };

    case "PROD_ASSET_NAME_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          name: action.payload
        }
      };

    case "PROD_ASSET_ASSET_ID_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          assetID: action.payload
        }
      };

    case "PROD_ASSET_SOURCE_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          source: action.payload
        }
      };

    case "PROD_ASSET_SOURCE_ID_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          sourceID: action.payload
        }
      };

    case "PROD_ASSET_PERIOD_NUMBER_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          periodNumber: action.payload
        }
      };

    case "PROD_ASSET_PERIOD_TYPE_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          periodType: action.payload
        }
      };
    case "PROD_ASSET_NAME_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          name: action.payload
        }
      };

    case "TYPE_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          assetType: action.payload
        }
      };
    case "REGISTRY_COMPLIANCE_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          registryCompliance: action.payload
        }
      };

    case "CAPACITY_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          capacityWh: parseInt(action.payload, 10)
        }
      };

    case "OPERATIONAL_SINCE_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          operationalSince: parseInt(action.payload, 10)
        }
      };
    
      

    case "DISPLAY_GRAPH_DATA_PRODUCING_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          displayGraphData: action.payload
        }
      };

    case "TIME_ZONE_PRODUCING_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          momentTimezone: action.payload
        }
      };

    case "ACTIVE_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          active: action.payload
        }
      };

    case "LOCATION_CHANGED":
      return {
        ...state,
        currentAssetProducing: {
          ...state.currentAssetProducing,
          city: action.payload.city,
          country: action.payload.country,
          gpsLatitude: action.payload.gpsLatitude,
          gpsLongitude: action.payload.gpsLongitude,
          //gpsLatitude: action.payload.gpsLatitude.toString().replace(".", ","),
          //gpsLongitude: action.payload.gpsLongitude.toString().replace(".", ","),
          houseNumber: action.payload.houseNumber,
          region: action.payload.region,
          street: action.payload.street,
          zip: action.payload.zip
        }
      };

    //Getting assetsProducing
    case "GET_ASSETS_PRODUCING_START":
      return { ...state };
    case "GET_ASSETS_PRODUCING_SUCCESS":
      return { ...state, assetsProducing: action.payload, loading: false };
    case "GET_ASSETS_PRODUCING_FAIL":
      return { ...state, loading: false };
    case "SORT_ASSETS":
      const assetsProducing = action.payload.assetsProducing;
      const order = action.payload.order;
      const orderBy = action.payload.orderBy;
      return { ...state, assetsProducing, order, orderBy };
    case "CHANGE_PAGE":
      const page = action.payload.page;
      return { ...state, page };
    case "CHANGE_ROWS_PER_PAGE":
      const rowsPerPage = action.payload.rowsPerPage;
      return { ...state, rowsPerPage };
    case "GET_ASSET_PRODUCING_START":
      return { ...state, loading: true };
    case "GET_ASSET_PRODUCING_SUCCESS":
      return { ...state, currentAssetProducing: action.payload };
    case "GET_ASSET_PRODUCING_FAIL":
      return { ...state, loading: false };
    case "RESET_ASSET_PRODUCING":
      return {
        ...state,
        currentAssetProducing: {
          id: undefined,
          houseNumber: "",
          street: "",
          region: "",
          city: "",
          zip: "",
          country: "",
          gpsLatitude: "",
          gpsLongitude: "",
          owner: "",
          smartMeter: "",
          organization: {},
          organizations: [],
          operationalSince: moment().format("x"),
          momentTimezone: "",
          active: true,
          displayGraphData: true,
          assetType: 0,
          capacityWh: 0,
          registryCompliance: 0,
          otherGreenAttributes: "N/A",
          typeOfPublicSupport: "N/A"
        }
      };
    case "GET_ASSET_PRODUCING_FORM_START":
      return { ...state, loadingForm: true };
    case "GET_ASSET_PRODUCING_FORM_SUCCESS":
      return {
        ...state,
        currentAssetProducing: action.payload,
        loadingForm: false
      };
    case "GET_ASSET_PRODUCING_FORM_FAIL":
      return { ...state, loadingForm: false };

    case "SAVE_PRODUCING_SMART_METER_READ_START":
      return { ...state, loadingMeterRead: true };
    case "SAVE_PRODUCING_SMART_METER_READ_SUCCESS":
      return { ...state, loadingMeterRead: false };
    case "SAVE_PRODUCING_SMART_METER_READ_FAIL":
      return { ...state, loadingMeterRead: false };

    case "LOGOUT_SUCCESS":
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default assetsProducingReducer;



// WEBPACK FOOTER //
// ./src/reducers/assetsProducingReducer.js